import React from 'react';
import Layout from 'layout/Layout';
import PreviewingReservationDetailComponent from 'components/PreviewingReservationDetailComponent';

const PreviewingReservationDetailPage: React.FC = () => {
  const pageTitle = '予約内容確認';

  return (
    <Layout pageTitle={pageTitle}>
      <PreviewingReservationDetailComponent></PreviewingReservationDetailComponent>
    </Layout>
  );
};
export default PreviewingReservationDetailPage;
